import { render } from "./ActionWait.vue?vue&type=template&id=3e374352"
import script from "./ActionWait.vue?vue&type=script&lang=ts"
export * from "./ActionWait.vue?vue&type=script&lang=ts"
script.render = render

export default script